import GetInTouch from "components/getInTouch";
import Featured from "components/homepage/featured";
import Reviews from "components/homepage/reviews";
import TranslateAgency from "components/homepage/translateAgency";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import Layout from "components/layout";
import LocationBanner from "components/locationBanner";
import SEO from "components/seo";
import React from "react";

const Languages = (props) => {
  const title = "About us | Tomedes Translation Services";
  const description =
    "Tomedes is a leading translation agency with more than 95,000 customers and thousands of professional translators. Want to get in touch with us? - support@tomedes.com | +1 985 239 0142";
  const keywords = "about tomedes, about translation company";
  const slug = "/about-tomedes";
  const {
    pageContext: {
      data: { data },
    },
  } = props;

  const firstWord = data.title_x.split(" ")[0];

  let filterVowel = typeof firstWord?.[0] === 'string' ? firstWord[0].toLowerCase().toString() : "";

  let vowels = ["a", "e", "i", "o", "u"];

  let vow = "A";

  vowels.forEach((item) => {
    if (filterVowel == item) {
      vow = "An";
    }
  });

  return (
    <Layout>
      {data.slug === slug ? (
        <SEO
          title={title}
          description={description}
          keywords={keywords}
          slug={slug}
        />
      ) : (
        <>
          <SEO
            title={data.Title_tag_value}
            description={data.Meta_tag_desc}
            keywords={data.Meta_tag_keywords}
            slug={data.slug}
          />
          <LocationBanner
            title={data.title_x}
            content={data.Meta_tag_desc}
            formOrangeHead="Get in touch"
            formWhiteHead=""
            backgroundCol="bg-midBlue"
            // styleOne={variant || variant_mobile}
            // styleOne="1"
          />
          <TranslateAgency firstWord={firstWord} vow={vow} />
        </>
      )}
      <div
        className={"service_wrapper " + data.slug.replace(/[^a-zA-Z]+/g, "")}
        dangerouslySetInnerHTML={{ __html: data.SEOCMSPageContent }}
      />

      <Reviews backgroundCol="bg-darkBlue" />
      <TranslationServices
        backgroundCol="bg-midBlue"
        LanguageName={firstWord}
        // styleOne={variant || variant_mobile}
        // styleOne="1"
      />
      <Featured backgroundCol="bg-darkBlue" />
      <WhatChooseUs backgroundCol="bg-midBlue" LanguageName={firstWord} />
      <GetInTouch backgroundCol="bg-darkBlue" />
    </Layout>
  );
};
export default Languages;
